export const environment = {
  production: false,
  instrumentationKey: "",
  apiUrl: "https://wtv-api-dev.azure.chevron.com",
  redirectUri: "https://wtv-dev.azure.chevron.com"
};
